import { render, staticRenderFns } from "./vs_csm_trn_approvemodal.vue?vue&type=template&id=b7c33e20&scoped=true"
import script from "./vs_csm_trn_approvemodal.vue?vue&type=script&lang=js"
export * from "./vs_csm_trn_approvemodal.vue?vue&type=script&lang=js"
import style0 from "./vs_csm_trn_approvemodal.vue?vue&type=style&index=0&id=b7c33e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c33e20",
  null
  
)

export default component.exports